import { createSelector } from 'reselect'
import { getSubTotalCartSelector } from 'modules/cart/selectors/get-sub-total'
import { getDiscountCartSelector } from 'modules/cart/selectors/get-discount'

function getSubTotalWithDiscountsCartSelector () {
  return createSelector(
    getSubTotalCartSelector(),
    getDiscountCartSelector(),
    (subTotal, discount) => {
      return subTotal - discount
    }
  )
}

export {
  getSubTotalWithDiscountsCartSelector
}
